import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-press',
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PressComponent implements OnInit, OnDestroy {
  pressRoomImage =
    'https://cdn.sanity.io/images/jizm7zxy/production/1a237ab87d39c29cda3b3aa12b94c34325a05607-1920x1054.png?fm=webp&q=75';
  pressRoomImageAlt = $localize`:@@pressRoomImageAlt:Press room image`;
  pressRoomTitle = $localize`:@@pressRoomTitle:Wipperoz press room`;
  pressRoomSubtitle = $localize`:@@pressRoomSubtitle:Wipperoz news, announcements, logo and more.`;
  constructor() {}

  ngOnInit(): void {}
  ngOnDestroy(): void {}
}
